import styled from "styled-components";
import { Container } from "../../styles/Container";

export const Wrapper = styled.div`
  margin: 5rem auto;

  ${Container}
`;

export const Content = styled.div`
  width: 100%;
  padding: 1rem 0;
  text-align: center;

  h1 {
    font-size: 72px;
  }
  p {
    width: 80%;
    margin: 1rem auto;
    line-height: 2rem;
    font-weight: 300;
  }
`;
